<loyaltic-header-comingsoon></loyaltic-header-comingsoon>
    <section class="comingsoon {{culture}}">
        <div class="container text-center">
            <!-- -->
            <div class="row justify-content-center">
                <div class="col-sm-8 col-xl-6">
                    <div [innerHTML]="comingsoonlclKey | translate">
                        <!-- <h1 class="mb-4">
                            Coming soon!
                        </h1>
                        <h5>
                            Campaign duration: 4/7-6/9/2022
                        </h5>
                        <p>

                        </p> -->
                    </div>
                </div>
            </div>
        </div>
    </section>

<loyaltic-footer-comingsoon></loyaltic-footer-comingsoon>
